var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdentificationDocIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12079",
    "data-name": "Rectangle 12079",
    width: 42,
    height: 42,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38571",
    "data-name": "Group 38571",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23066",
    "data-name": "Path 23066",
    d: "M38.579,27.968h-.789c-2.228,0-5.5-2.59-5.869-2.885l1.014-1.258c1.212.977,3.6,2.527,4.855,2.527h.789Z",
    transform: "translate(-6.138 -4.582)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23067",
    "data-name": "Path 23067",
    d: "M13.433,36.843A3.948,3.948,0,0,1,10,35.165a.808.808,0,0,1-.023-.868c.783-1.305,3.9-7.015,3.929-7.072a.811.811,0,0,1,.261-.285l7.1-4.735a.8.8,0,0,1,.531-.131l2.631.271-.166,1.607-2.343-.241-6.693,4.462c-.485.887-2.606,4.768-3.574,6.454,1.156,1.058,3.145.4,3.167.4l.517,1.53a6.464,6.464,0,0,1-1.9.29",
    transform: "translate(-1.896 -4.244)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23068",
    "data-name": "Path 23068",
    d: "M12.284,44.44l-.707-1.452,4.139-2.014,1.618-1.938,1.24,1.035-1.729,2.071a.8.8,0,0,1-.267.209Z",
    transform: "translate(-2.226 -7.507)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23069",
    "data-name": "Path 23069",
    d: "M18.115,31.331l-1.21-1.071,13.9-15.7a2.5,2.5,0,0,1,1.787-.828,2.487,2.487,0,0,1,1.93,4.131L22.888,31.27l-1.22-1.058L33.307,16.8a.876.876,0,0,0-.033-1.2.947.947,0,0,0-.639-.255.862.862,0,0,0-.624.288Z",
    transform: "translate(-3.251 -2.64)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23070",
    "data-name": "Path 23070",
    d: "M29.764,40.972H27.4c-1.735,0-2.731-.938-3.785-1.93-.152-.141-.307-.288-.469-.437H17.929c-2.724,0-3.131-1.753-3.131-2.8a2.914,2.914,0,0,1,3.131-2.762h6.312a1.713,1.713,0,0,0,1.56-1.559V29.907h1.615v1.578a3.3,3.3,0,0,1-3.175,3.174H17.929c-.393,0-1.515.211-1.515,1.147,0,.647.114,1.182,1.515,1.182h5.523a.811.811,0,0,1,.535.2c.26.23.5.457.732.674.954.9,1.584,1.491,2.678,1.491h2.367a7.947,7.947,0,0,0,1.86-.41l.408-.12a9.027,9.027,0,0,1,2.466-.258h.789v1.615H34.5a7.625,7.625,0,0,0-2.022.2l-.388.114a8.892,8.892,0,0,1-2.324.479",
    transform: "translate(-2.846 -5.751)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23071",
    "data-name": "Path 23071",
    d: "M45.495,40.028H39.972a.807.807,0,0,1-.808-.808V25.808A.808.808,0,0,1,39.972,25h5.523a.807.807,0,0,1,.808.808V39.22a.807.807,0,0,1-.808.808m-4.715-1.615h3.908v-11.8H40.779Z",
    transform: "translate(-7.532 -4.808)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12075",
    "data-name": "Rectangle 12075",
    width: 1.615,
    height: 1.578,
    transform: "translate(34 30.468)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23072",
    "data-name": "Path 23072",
    d: "M30.842,40.442H4.806A.807.807,0,0,1,4,39.634V3.341a.807.807,0,0,1,.808-.808H30.842a.807.807,0,0,1,.808.808v6.8H30.035v-6H5.613V38.827H30.035V36.478H31.65v3.156a.807.807,0,0,1-.808.808",
    transform: "translate(-0.769 -0.487)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23073",
    "data-name": "Path 23073",
    d: "M24.786,43.038h-.057c-1.914-.017-3.148-.888-3.148-2.228v-.157H23.2v.157c0,.395.806.61,1.572.613a2.217,2.217,0,0,0,1.443-.372l1.126,1.157a3.7,3.7,0,0,1-2.531.83h-.02",
    transform: "translate(-4.15 -7.818)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23074",
    "data-name": "Path 23074",
    d: "M19.522,43.038h-.068A2.652,2.652,0,0,1,17,41.826l1.42-.771c.121.224.534.364,1.079.367.306,0,1.2-.057,1.2-.613v-.157h1.615v.157c0,1.315-1.108,2.2-2.766,2.228h-.028",
    transform: "translate(-3.27 -7.818)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23075",
    "data-name": "Path 23075",
    d: "M12.617,43.843l-1.581-.334.792-3.742a.824.824,0,0,1,.184-.366l.494-.563L13.72,39.9l-.355.4Z",
    transform: "translate(-2.122 -7.469)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23076",
    "data-name": "Path 23076",
    d: "M11.323,14.026a.806.806,0,0,1-.571-.237L9.175,12.211l1.142-1.142.939.94,2.593-3.24,1.262,1.01-3.156,3.945a.808.808,0,0,1-.586.3h-.045",
    transform: "translate(-1.764 -1.686)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23077",
    "data-name": "Path 23077",
    d: "M11.323,23.794a.806.806,0,0,1-.571-.237L9.175,21.979l1.142-1.142.939.94,2.593-3.24,1.262,1.01-3.156,3.945a.808.808,0,0,1-.586.3h-.045",
    transform: "translate(-1.764 -3.565)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12076",
    "data-name": "Rectangle 12076",
    width: 3.945,
    height: 1.615,
    transform: "translate(16.66 14.669)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12077",
    "data-name": "Rectangle 12077",
    width: 7.101,
    height: 1.615,
    transform: "translate(16.66 9.935)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12078",
    "data-name": "Rectangle 12078",
    width: 3.156,
    height: 1.615,
    transform: "translate(16.661 6.779)",
    fill: "#010101"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentificationDocIcon);
export default __webpack_public_path__ + "static/media/Identification_doc_icon.67a623fda5645606bd2bca5f299b13b0.svg";
export { ForwardRef as ReactComponent };